(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["group"] && !Shopify.designMode) return;
  try {
    (function() {
    document.querySelectorAll('[data-sticky="true"]').forEach(function(el) {
      var offset = parseInt(el.getAttribute('data-sticky-offset')) || 0;
      var parent = el.parentElement;

      // Arregla el overflow del padre para que sticky funcione
      while (parent && parent !== document.body) {
        var overflow = window.getComputedStyle(parent).overflow;
        var overflowY = window.getComputedStyle(parent).overflowY;
        if (overflow === 'hidden' || overflowY === 'hidden') {
          parent.style.overflow = 'visible';
        }
        parent = parent.parentElement;
      }

      el.style.position = 'sticky';
      el.style.top = offset + 'px';
      el.style.alignSelf = 'flex-start';
      el.style.zIndex = '10';
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
